import { render, staticRenderFns } from "./OnglesContainer.vue?vue&type=template&id=277f2729&"
import script from "./OnglesContainer.vue?vue&type=script&lang=js&"
export * from "./OnglesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports